export const IMAGE_MAX_MB_SIZE = 5;
